import { v4 } from "uuid";

export enum ModalType {
	IFRAME = "iframe"
}

export interface IModal {
	uid:string;
	type:ModalType;
	data:any;
	title?:string;
	options:any;
	width?:number;
	height?:number;
}

export interface IFrameModalOptions {
	padded?:boolean;
	width?:number;
	height?:number;
}

export class ModalServiceClass {
	public modals:IModal[] = [];

	public openIframeModal(link:string, title:string, options:IFrameModalOptions = {}){
		this.modals.push({type: ModalType.IFRAME, data: link, title, uid: v4(), options, width: options.width, height: options.height});
	}
}

export const ModalService = new ModalServiceClass();